import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isRegenerate", "loading"];
import styled from 'styled-components';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { AITransparentLoadingButton } from './AITransparentLoadingButton';
import { BreezeStarSVG } from './BreezeStarSVG';
import { getStyledAIButton } from './styledButtons/StyledAIBaseButton';
import { StyledAIBaseLoadingButtonAnimation } from './styledButtons/AILoadingButtonAnimations';
import { TRANSPARENT } from '../../../types/AIButtonUseTypes';

// Using the icon font directly as the UIIcon adds a lot of overhead to positioning of the icon in the animation
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyleFontBasedBreezeIcon = styled.div.withConfig({
  displayName: "AIBaseLoadingButton__StyleFontBasedBreezeIcon",
  componentId: "xov26g-0"
})(["font-family:'spacesword',sans-serif;font-size:1em;"]);
export function AIBaseLoadingButton(_ref) {
  let {
      children,
      isRegenerate = true,
      loading
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [animationPhase, setAnimationPhase] = useState('idle');
  const [buttonWidth, setButtonWidth] = useState(0);
  const buttonRef = useRef(null);
  const isTransparent = uiButtonProps.use === TRANSPARENT;
  const transparentPhase = loading ? 'loading' : 'idle';
  useEffect(() => {
    // Make sure to check the width when the animation starts
    if (buttonRef.current && animationPhase === 'start') {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, [animationPhase]);
  useLayoutEffect(() => {
    if (loading && animationPhase === 'idle') {
      setAnimationPhase('start');
    }
    if (!loading && animationPhase === 'loading') {
      setAnimationPhase('end');
    }
  }, [loading, animationPhase]);
  const handleAnimationEnd = () => {
    if (animationPhase === 'start') {
      setAnimationPhase('loading');
    } else if (animationPhase === 'end') {
      setAnimationPhase('idle');
    }
  };
  const AIButtonComponent = getStyledAIButton(uiButtonProps.use);
  return /*#__PURE__*/_jsx(AIButtonComponent, Object.assign({}, uiButtonProps, {
    children: /*#__PURE__*/_jsx("span", {
      ref: buttonRef,
      children: isTransparent ? /*#__PURE__*/_jsx(AITransparentLoadingButton, Object.assign({
        isRegenerate: Boolean(isRegenerate),
        transparentPhase: transparentPhase
      }, uiButtonProps, {
        children: children
      })) : /*#__PURE__*/_jsxs(StyledAIBaseLoadingButtonAnimation, {
        buttonWidth: buttonWidth,
        isRegenerate: Boolean(isRegenerate),
        children: [/*#__PURE__*/_jsx("span", {
          className: `${animationPhase} ai-loading-icon-container`,
          onAnimationEnd: handleAnimationEnd,
          children: /*#__PURE__*/_jsxs("span", {
            className: `${animationPhase} ai-icons`,
            children: [/*#__PURE__*/_jsx(StyleFontBasedBreezeIcon, {
              className: `${animationPhase} ai-refresh-icon`,
              children: "breezeRegenerate"
            }), /*#__PURE__*/_jsx(BreezeStarSVG, {
              className: `${animationPhase} ai-loading-icon`,
              use: uiButtonProps.use,
              isDisabled: uiButtonProps.disabled
            })]
          })
        }), /*#__PURE__*/_jsx("span", {
          className: `${animationPhase} ai-loading-children`,
          children: children
        })]
      })
    })
  }));
}